"use strict";import{tag as a}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Cross200Icon=({width:t=24,height:e=24,title:r="Cross200"}={})=>a`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    aria-hidden="true"
    role="img"
    fill="currentColor"
    aria-label=${r}
    width=${t}
    height=${e}
  >
    <path
      d="M6.29 5l2.922-2.922a.911.911 0 00-1.29-1.29L5 3.712 2.078.789a.911.911 0 00-1.29 1.289L3.712 5 .79 7.922a.911.911 0 101.289 1.29L5 6.288 7.923 9.21a.911.911 0 001.289-1.289z"
    />
  </svg>`;
//# sourceMappingURL=Cross200.js.map
